import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa80336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pretensions" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "pretensions__filters__inputs" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "fas fa-check text-green-500"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pretension_form = _resolveComponent("pretension-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.form_state.is_visible)
      ? (_openBlock(), _createBlock(_component_pretension_form, {
          key: 0,
          "initial-value": _ctx.form_state.initial_value,
          "is-update": _ctx.form_state.is_update,
          "is-create": _ctx.form_state.is_create,
          onRefresh: _ctx.closePretensionForm
        }, null, 8, ["initial-value", "is-update", "is-create", "onRefresh"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Претензии" }),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.onAddPretension
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить претензию ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("form", {
            class: "pretensions__filters",
            onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.loadPretensions(1)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "ID",
                value: _ctx.filters_state.id,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.id) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Номер накладной",
                value: _ctx.filters_state.invoice_number,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.invoice_number) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Контрагент",
                value: _ctx.filters_state.company_name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.company_name) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "ФИО клиента",
                value: _ctx.filters_state.client_name,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.client_name) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Описание товара",
                value: _ctx.filters_state.product_description,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.product_description) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "w-full mt-2",
                placeholder: "Тип претензии",
                options: _ctx.state.pretensions_types,
                "select-by": "id",
                value: _ctx.filters_state.type_id,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.type_id) = $event))
              }, null, 8, ["options", "value"]),
              _createVNode(_component_the_input, {
                type: "date",
                class: "w-full",
                placeholder: "Создана от",
                value: _ctx.filters_state.from_date,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.from_date) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                type: "date",
                class: "w-full",
                placeholder: "Создана до",
                value: _ctx.filters_state.to_date,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.to_date) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "w-full h-full mt-2",
                placeholder: "Статус претензии",
                options: _ctx.state.pretensions_statuses,
                "select-by": "code",
                value: _ctx.filters_state.status_code,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.status_code) = $event))
              }, null, 8, ["options", "value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Подразделение",
                loading: _ctx.state.subdivisions.is_loading,
                failed: _ctx.state.subdivisions.is_failed,
                "error-text": "При получении списка подразделений произошла ошибка",
                options: _ctx.state.subdivisions.list,
                value: _ctx.filters_state.subdivision_id,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters_state.subdivision_id) = $event)),
                onRefresh: _ctx.loadSubdivisions
              }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Виновная сторона",
                loading: _ctx.state.guilty_sides.is_loading,
                failed: _ctx.state.guilty_sides.is_failed,
                "error-text": "При получении списка виновных сторон произошла ошибка",
                options: _ctx.state.guilty_sides.list,
                value: _ctx.filters_state.guilty_side_id,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters_state.guilty_side_id) = $event)),
                onRefresh: _ctx.loadGuiltySides
              }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Компенсанция",
                "select-by": "value",
                searchable: false,
                options: _ctx.HAS_COMPENSATION_OPTIONS,
                value: _ctx.filters_state.has_compensation,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters_state.has_compensation) = $event))
              }, null, 8, ["options", "value"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_button, {
                class: "second text small mr-2",
                loading: _ctx.state.pretensions.is_loading,
                onClick: _ctx.resetFilters
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Сброс ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary text small",
                loading: _ctx.state.pretensions.is_loading,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_page_title, {
              title: "Список претензий",
              class: "mb-3"
            }),
            (
                        _ctx.state.pretensions.is_failed &&
                        !_ctx.state.pretensions.failure.error_state.is_cancel
                    )
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.pretensions.is_loading,
                  text: "При получении списка договоров произошла ошибка",
                  "error-message": _ctx.state.pretensions.failure.error_state.message,
                  "error-url": _ctx.state.pretensions.failure.error_state.url,
                  "error-status": _ctx.state.pretensions.failure.error_state.status,
                  onRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadPretensions(_ctx.state.pretensions.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  loading: _ctx.state.pretensions.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.state.pretensions.is_loading,
                      columns: _ctx.PretensionsColumns,
                      rows: _ctx.state.pretensions.list,
                      "with-limit": "",
                      "pagination-limit": _ctx.filters_state.limit,
                      "pagination-total-items": _ctx.state.pretensions.pagination.total_items,
                      "pagination-current-page": _ctx.state.pretensions.pagination.current_page,
                      "pagination-total-pages": _ctx.state.pretensions.pagination.total_pages,
                      onChangePage: _ctx.loadPretensions,
                      onChangeLimit: _ctx.onLimitChange
                    }, {
                      buttons: _withCtx(() => [
                        _createVNode(_component_the_button, {
                          class: "primary text small mr-3",
                          onClick: _ctx.exportExcel,
                          loading: _ctx.state.is_loading,
                          hint: "Скачать в Excel"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      td: _withCtx(({ row, column }) => [
                        (row.hasAttachments && column.key === 'final_file')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                          : (row.status_name && column.key === 'status_name')
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 1,
                                class: _normalizeClass(["small", {
                                        primary: row.status_id === 1,
                                        yellow: [2, 3, 4, 7, 8, 9].includes(row.status_id),
                                        green: row.status_id === 5,
                                        red: row.status_id === 6,
                                    }])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.status_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : (column.key === 'product_description')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.cut(row.product_description, 15)), 1)
                                ], 64))
                              : (column.key === 'created_at')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDate(row.created_at)), 1)
                                  ], 64))
                                : (column.key === 'delivery_date')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.delivery_date)), 1)
                                    ], 64))
                                  : (column.key === 'guilty_side')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(row.guilty_side ? row.guilty_side.name : '-'), 1)
                                      ], 64))
                                    : (column.key === 'id')
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 6,
                                          class: "text-blue-500",
                                          to: `/pretensions/${row.id}`,
                                          target: "_blank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(row.id), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                                        ], 64))
                      ]),
                      actions: _withCtx(({ row }) => [
                        _createVNode(_component_the_button, {
                          class: "yellow small",
                          hint: "Редактировать",
                          onClick: ($event: any) => (_ctx.onUpdatePretension(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ], 64))
  ]))
}